module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"graphFileTitle":"Number of Files Trends (last 7 days)","graphSnapshotsTitle":"Number of Snapshots Trends (last 7 days)"},"zh":{"graphFileTitle":"近7日聚档数量曲线","graphSnapshotsTitle":"近7日聚类任务抓拍数量曲线"}}')
  delete Component.options._Ctor
}
